import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;
  const isActivePath = (path) => location.pathname.startsWith(path);

  return (
    <header className={`header ${scrolled ? "header-scrolled" : ""}`}>
      <div className="container">
        <Link to="/" className="logo">
          <div className="logo-mark">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
            </svg>
          </div>
          <span className="logo-text">E-Shops <span>SEO</span></span>
        </Link>
        
        <nav className={`nav ${menuOpen ? "nav-open" : ""}`}>
          <Link to="/" className={isActive("/") ? "active" : ""} onClick={() => setMenuOpen(false)}>
            Accueil
          </Link>
          <Link to="/avantages" className={isActive("/avantages") ? "active" : ""} onClick={() => setMenuOpen(false)}>
            Avantages
          </Link>
          <Link to="/categories" className={isActive("/categories") ? "active" : ""} onClick={() => setMenuOpen(false)}>
            Realisations
          </Link>
          <Link to="/blog" className={isActivePath("/blog") ? "active" : ""} onClick={() => setMenuOpen(false)}>
            Blog
          </Link>
          <Link to="/contact" className="nav-cta" onClick={() => setMenuOpen(false)}>
            Devis gratuit
          </Link>
        </nav>
        
        <button className={`menu-toggle ${menuOpen ? "menu-open" : ""}`} onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
}

export default Header;
